document.addEventListener("DOMContentLoaded",()=>{

const hero=document.querySelector(".bymoqa-hero");

const media=document.querySelector(".bymoqa-hero-media");

const video=document.querySelector(".bymoqa-hero-video");

const content=document.querySelector(".bymoqa-hero-content");

if(!hero||!video)return;

video.play().catch(()=>{});

video.animate(
[
{opacity:0},
{opacity:1}
],
{
duration:700,
fill:"forwards"
}
);

let current=0;

let target=0;

function loop(){

target=window.scrollY;

current+=(target-current)*0.08;

const progress=Math.min(

current/window.innerHeight,

1

);

/* VIDEO */

media.style.transform=

`translateY(${current*-0.12}px)`;

/* VIDEO SCALE */

video.style.transform=

`translate(-50%,-50%)
scale(${1.12-progress*0.06})`;

/* TEXT */

if(content){

content.style.transform=

`translateY(${progress*-90}px)`;

content.style.opacity=

1-progress*1.3;

}

requestAnimationFrame(loop);

}

loop();

});